import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-backoffice-esim-details-modal',
  templateUrl: './esim-details-modal.component.html',
  styleUrls: ['./esim-details-modal.component.scss']
})
export class BOEsimDetailsModalComponent {
  
  constructor(
    public dialogRef: MatDialogRef<BOEsimDetailsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translate: TranslateService
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }

  openEsimDetails(): void {
    const idPkg = this.data.originalData?.pkg_details?.id_pkg;
    if (idPkg) {
      const url = `/esim-details?package_id=${idPkg}`;
      window.open(url, '_blank');
    }
  }

  calculateUsagePercentage(total: number, remaining: number): number {
    if (total === 0) {
      return 0;
    }
    return ((total - remaining) / total) * 100;
  }

  formatUsageDisplay(used: number, total: number, type: string = 'data'): string {
    const percentage = total > 0 ? Math.round((used / total) * 100) : 0;
    
    if (type === 'data') {
      const usedGB = used.toFixed(0);
      const totalGB = total.toFixed(0);
      return `${usedGB} / ${totalGB} (${percentage}%)`;
    } else {
      return `${used} / ${total} (${percentage}%)`;
    }
  }

  getUsagePercentage(used: number, total: number): number {
    if (total === 0) return 0;
    return Math.round((used / total) * 100);
  }

  getStatusColor(status: string): string {
    switch (status) {
      case 'ACTIVE':
        return 'text-green-600 bg-green-100';
      case 'NOT_ACTIVE':
        return 'text-gray-600 bg-gray-100';
      case 'FINISHED':
        return 'text-blue-600 bg-blue-100';
      case 'EXPIRED':
        return 'text-red-600 bg-red-100';
      case 'UNKNOWN':
        return 'text-yellow-600 bg-yellow-100';
      default:
        return 'text-gray-600 bg-gray-100';
    }
  }

  // Conditional date display methods
  shouldShowActivationDate(): boolean {
    const status = this.data.status;
    return ['ACTIVE', 'FINISHED', 'EXPIRED'].includes(status) &&
           this.data.activationDate != null;
  }

  shouldShowExpiryDate(): boolean {
    return this.data.status === 'ACTIVE' && this.data.expiryDate != null;
  }

  shouldShowFinishDate(): boolean {
    return this.data.status === 'FINISHED' && this.data.finishDate != null;
  }

  shouldShowExpiredDate(): boolean {
    return this.data.status === 'EXPIRED' && this.data.expiredDate != null;
  }

  shouldShowRecyclingDeadline(): boolean {
    return this.data.status === 'NOT_ACTIVE' && this.data.recyclingDeadlineDate != null;
  }

  shouldShowRecycledDate(): boolean {
    return this.data.status === 'RECYCLED' && this.data.recycledDate != null;
  }

  // Conditional usage display methods
  shouldShowVoiceUsage(): boolean {
    return this.data.voiceLimit > 0;
  }

  shouldShowTextUsage(): boolean {
    return this.data.textLimit > 0;
  }

  shouldShowDataUsage(): boolean {
    return this.data.dataLimit > 0;
  }

  shouldShowUsageCard(): boolean {
    return this.shouldShowVoiceUsage() ||
           this.shouldShowTextUsage() ||
           this.shouldShowDataUsage();
  }

}
